module.exports = __webpack_public_path__ + "img/qipao.d439e45c.png";